import Swiper, { Autoplay, Keyboard, Navigation } from 'swiper';
import $ from "jquery";

export default function headerslider() {
  const swiper = new Swiper('.swiper', {
    modules: [Autoplay, Keyboard, Navigation],
    loop: true,
    keyboard: true,
    autoplay: {
      delay: 5000,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swipe-next',
      prevEl: '.swipe-prev',
    },
  });

  swiper.on('slideChangeTransitionEnd', function () {
    let currentSlide = swiper.activeIndex - 1;
    let lastSlide = document.querySelector(`.carousel-indicators li:last-child`).getAttribute('data-slide-to');
    document.querySelector('.carousel-indicators li.active').classList.remove('active');

    if (currentSlide == '-1') {
      document.querySelector(`.carousel-indicators li:last-child`).classList.add('active');
    } else if(currentSlide > lastSlide) {
      document.querySelector(`.carousel-indicators li:first-child`).classList.add('active');
    } else {
      document.querySelector(`.carousel-indicators li[data-slide-to="${currentSlide}"]`).classList.add('active');
    }
  });

  let sliderBubbles = document.querySelectorAll('.carousel-indicators li');

  for (const property of sliderBubbles) {
    property.addEventListener("click", function() {
      const currentIndex = this.getAttribute('data-slide-to');
      document.querySelector('.carousel-indicators li.active').classList.remove('active');
      this.classList.add('active');
      swiper.slideToLoop(currentIndex);
    })
  }

  function showHideIndicators() {
    $('.swiper').addClass('swiper--mobile');

    if ($(window).width() >= 768) {
      $('.swiper').removeClass('swiper--mobile');

      $('.carousel-caption .description').on('mouseenter', function () {
        $('.carousel-caption .description h3').animate({'opacity': 0}, 300);
        $('.carousel-indicators').fadeIn();
      });
      $('.carousel-indicators').on('mouseleave', function () {
        $('.carousel-caption .description h3').animate({'opacity': 1}, 300);
        $(this).fadeOut();
      });
    }
  }

  showHideIndicators();

  $(window).resize(function() {
    showHideIndicators();
  });
}